import React, { Component } from "react";
import { prefix, t } from "../../../i18n";
import { Redirect } from "react-router-dom";
import { withShoppingCartContainer } from "../../containers/gamification2026";
import { ReactComponent as Box } from "../../../assets/img/box.svg";
import CustomLink from "../shared/CustomLink";

const tCartCheckout = prefix("cart-checkout");

class CartSuccess extends Component {
  componentWillUnmount() {
    this.props.fetchCart();
  }
  render() {
    const { cart, campaignUser } = this.props;
    const hasPaymentInformation =
      !!campaignUser.entity && !!campaignUser.reference && !!campaignUser.value;
    if (!cart.shipment_address) {
      return <Redirect to="/cart" />;
    }
    return (
      <div>
        {hasPaymentInformation && (
          <>
            <h1 className="title_payment_data">
              {t("gamification2026.cart.payment-data")}
            </h1>
            <table className="table_payment_data">
              <thead>
                <tr>
                  <th className="table_payment_data_th">
                    <strong>{t("gamification2026.cart.entity")}</strong>
                    {campaignUser.entity}
                  </th>
                  <th className="table_payment_data_th">
                    <strong>{t("gamification2026.cart.reference")}</strong>
                    {campaignUser.reference}
                  </th>
                  <th className="table_payment_data_th">
                    <strong>{t("gamification2026.cart.value")}</strong>
                    {parseFloat(campaignUser.value).toFixed(2)} &euro;
                  </th>
                  {campaignUser.validity ? (
                    <th className="table_payment_data_th">
                      <strong>
                        {t("gamification2026.cart.validity-days")}
                      </strong>
                      {campaignUser.validity}
                    </th>
                  ) : null}
                </tr>
              </thead>
            </table>
          </>
        )}
        <div className="flex flex-col justify-center items-center">
          <Box className="dead-grey-fill mt-16 h-48" />
          <h2 className="my-3 dead-grey">
            {tCartCheckout("checkout-successfully")}
          </h2>
          <CustomLink className="mt-5" to="/catalog" primary>
            {tCartCheckout("return-to-store")}
          </CustomLink>
        </div>
      </div>
    );
  }
}

export default withShoppingCartContainer(CartSuccess);
